import { request } from '@umijs/max';

export interface DashboardStats {
  online_users: number;
  today_registered: number;
  today_logged_in: number;
  app_recharge_pending: number;
  app_withdraw_pending: number;
  crypto_recharge_pending: number;
  crypto_withdraw_pending: number;
  viber_unread_messages: number;
  viber_unread_users: number;
  shankoemee_online?: {
    total: number;
    real_users: number;
    robots: number;
    last_updated?: string;
  };
  boogyi_online?: {
    total: number;
    real_users: number;
    robots: number;
    last_updated?: string;
  };
}

export interface RealtimePoint { time: string; bet: number; payout: number }
export interface RealtimeStats {
  window_minutes: number;
  online_users: number;
  totals: { bet: number; payout: number };
  series: RealtimePoint[];
}

/**
 * 获取仪表盘统计数据
 */
export interface ApiResponse<T> { success: boolean; data?: T; message?: string; status?: number }
export async function getDashboardStats(): Promise<ApiResponse<DashboardStats>> {
  return request('/api/vl/admin/dashboard/stats', {
    method: 'GET',
  });
}

export async function getRealtimeStats(params?: { minutes?: number }): Promise<ApiResponse<RealtimeStats>> {
  return request('/api/vl/admin/dashboard/realtime', {
    method: 'GET',
    params,
  });
}
